import React, { useMemo } from 'react';
import { usePreferences } from '@context/preferences.context';
import { Product } from '@interfaces/models/product';
import sanitizer from '@helpers/sanitizer';
import { ContentsPageMetadata } from '@interfaces/models/contentsPageMetadata';
import { getSeoBaseUrlFromLocale } from '@helpers/utils/seo-structured-data';
import { createProductPageSchema } from './product-schema-utils';

type ProductSchemaProps = {
  product: Product;
  seoMetaData?: ContentsPageMetadata;
};

const ProductSchema: React.FC<ProductSchemaProps> = (props) => {
  const { product, seoMetaData } = props;
  const { locale } = usePreferences();
  const origin = getSeoBaseUrlFromLocale(locale);

  const schema = useMemo(() => createProductPageSchema(product, seoMetaData, origin), [product, seoMetaData, origin]);

  return (
    <script
      data-cy={`product-schema-${product.id}`}
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: sanitizer(JSON.stringify(schema)),
      }}
    />
  );
};

export default ProductSchema;
